module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA30lEQVQ4jdWQu04CURRF133MHQsSMX6AiZVKCAWFsaHyEyz9ECsKOn7nTk1BZSys7QwNDxNhQmIxXp17KIgUFIyPgriqk5zslX0O7BsFMD+/Ej5LcAm2eUH5PEIWOSTJzvDx073SAMQIqaPW72JOT9D1Q0zjDEKobKAB5D3grjuoozofD49IjMjrAnvZhrKsFmyu0Zo4noExkKbEycv3GqjUEQZDZJ5zcHuDcg6MRooClNopsGuNhiLwdtfDthrE6YyYL1HWrHdVeO/lp3jvZesHv2P/Avs1ZFn2V9d/ZQUAnnEl5/wO9gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/SG.png
// module id = 1260
// module chunks = 0